<template>
  <div>
    <div v-if="!true" class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#"
            @click="addPayout">
        <i class="fa fa-plus"></i> Add Payout
      </a>
    </div>
    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="''"
              id="payoutsTable" class="table-striped" 
              :data="invoices" :row-class-name="rowClasses">
      <!-- <el-table-column type="index">

      </el-table-column> -->
      
      
      <el-table-column width="160" label="Date created">
        <template slot-scope="{row}">
          <template v-if="row">
            {{displayDate(row.dateCreated)}}
          </template>
        </template>
      </el-table-column>
      
      <el-table-column width="100" label="Total due">
        <template slot-scope="{row}">
          <template v-if="row">
            <span style="font-size: 120%;">{{ displayAmount(calcTotal(row)) }} </span>
          </template>
        </template> 
      </el-table-column>
      
      <el-table-column width="85" label="Status" prop="status"/>
      
      <el-table-column width="100" label="Payouts">
        <template slot-scope="{row}">
          <template v-if="row">
            {{ displayAmount(calcPayoutsTotal(row)) }}
          </template>
        </template> 
      </el-table-column>
      
      <el-table-column width="100" label="Charges">
        <template slot-scope="{row}">
          <template v-if="row">
            {{ $store.getters.currency + calcChargesTotal(row) }}
          </template>
        </template> 
      </el-table-column>
      
      <el-table-column width="100" label="Taxes">
        <template slot-scope="{row}">
          <template v-if="row">
            {{ $store.getters.currency + Math.round(100*calcTaxesTotal(row))/100 }}
          </template>
        </template> 
      </el-table-column>
      
      <el-table-column label="Notes" prop="notes"/>


      <!-- <el-table-column v-if="selectObjects" width="30">
        <template slot-scope="{row}">
          <div>
            <l-checkbox v-show="rowSelectable(row)" :id="'selectpayout'+row.id" @change="selectRow(row)"/>
          </div>
        </template>
      </el-table-column> -->

      <el-table-column width="1">
        <template slot-scope="{row}">
          <div :payoutid="row.id"/>
        </template>
      </el-table-column>

    </el-table>
  </div>  
</template>

<script>
import {Affiliate, AffiliateCompanyProxy, Payout, Lead} from 'src/classes/datamodel.js'
import utils from '../../utils'
export default {
    name: 'Invoices-Table',
    props: {
      // hideAddPayout:  {type: Boolean, default: false}
      forAffiliate:  { type: Number, default: undefined }
    },
    computed: {
      invoices () {
        return this.$store.getters.invoices
      },
      selectObjects () {
        // return false if a modal is currently open
        return !this.$store.getters.modal.current && this.$store.getters.selectedObjectsJson
      }
    }, 
    methods: {
      displayDate (date) {
        return utils.dateToString(date)
      },
      displayAmount (amount) {
        return utils.displayAmount(amount)
      },
      calcTotal (invoice) {
        return utils.calcTotal(invoice)
      },
      calcPayoutsTotal (invoice) {
        return utils.calcPayoutsTotal(invoice)
      },
      calcChargesTotal (invoice) {
        return utils.calcChargesTotal(invoice)
      },
      calcTaxesTotal (invoice) {
        return utils.calcTaxesTotal(invoice)
      },

      rowClasses ({row, rowIndex}) {
        return row.archived ?'archivedTableRow' : ''
      },
      rowHover(row, column, cell, event) {
        // We show all buttons of class .showOnHover
        var rows = $('#payoutsTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var foundRow = JSON.stringify($(rows[i]).html().indexOf('payoutid="'+row.id+'"')) > -1
          var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
          if (foundRow && !archivedRow) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).removeClass('d-none')
            }
            break
          }
        }
      },
      rowHoverLeave (row, column, cell, event) {
        // We hide all buttons of class .showOnHover
        var rows = $('#payoutsTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var index = JSON.stringify($(rows[i]).html().indexOf('payoutid="'+row.id+'"'))
          if (index > -1) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).addClass('d-none')
            }
            break
          }
        }
      },
      // This method is called when clicking a checkbox to select a row
      // It's going to update the ObjectsWithId in the state (selectedObjects.objectsJson)
      selectRow (row) {
        this.$store.commit('SELECT_OBJECT', row)
      },
      rowSelectable (row) {
        if (this.$store.getters.selectedObjectsJson) { // if selection mode is active
          let filter = this.$store.getters.selectedObjectsFilter
          let filterKeys = filter ? Object.keys(filter) : []
          // we also check that the corresponding affiliate has an active card, and filter out otherwise
          let match = this.hasActiveCard(row)
          // we check the filter values
          filterKeys.forEach(key => {
            if (row[key] != filter[key]) {
              match = false
            }
          });
          return match
        }
        return false
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>